import { render, staticRenderFns } from "./pages13.vue?vue&type=template&id=4321586c&scoped=true&"
import script from "./pages13.vue?vue&type=script&lang=js&"
export * from "./pages13.vue?vue&type=script&lang=js&"
import style0 from "./pages13.vue?vue&type=style&index=0&id=4321586c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4321586c",
  null
  
)

export default component.exports